import React, { useState } from 'react'
import { postTablaInsumosMateralesPaquetes } from '../../../services/PaginaRuta'
import ModalPaquetesConfirmarCantidad from './ModalPaquetesConfirmarCantidad'
import ModalPaquetesRepetidos from './ModalPaquetesRepetidos'

const TablaSeleccionPaquetes = ({item, idCirugia, passActualizarTablaPaquetes}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [modalOnConfirmarCantidadPaquetes, setmodalOnConfirmarCantidadPaquetes]=useState(false)
  const [modalOnPaqueteRepetido, setmodalOnPaqueteRepetido]=useState(false)

  const handleOnclickPaquetes=()=>{
    const body = {
      varProEmpCod: usuarioInfo.Empresa,
      varProMCDpto: usuarioInfo.Sede,
      varProCirCod: idCirugia,
    };
    let codigoPaquete= item.PaqCod
    postTablaInsumosMateralesPaquetes(body).then((res)=>{
      let dataPaquetes = []
        dataPaquetes = res.data
        let buscarUnPaquete= dataPaquetes.some((item)=>item.PaqCod == codigoPaquete)
        if(!buscarUnPaquete){
          setmodalOnConfirmarCantidadPaquetes(true)
        }else{
          //console.log('repetido')
          setmodalOnPaqueteRepetido(true)
        }
    })
    
  }

  return (
    <>
    <tr className="border-b">
      <td className="text-xs font-medium py-2 whitespace-pre-wrap"><button
                type="button"
                onClick={handleOnclickPaquetes}
                className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Agregar
              </button></td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap">{item.PaqCod}</td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">{item.PaqDes}</td>      
    </tr>
      {modalOnConfirmarCantidadPaquetes? <ModalPaquetesConfirmarCantidad item={item} setmodalOnConfirmarCantidadPaquetes={setmodalOnConfirmarCantidadPaquetes} idCirugia={idCirugia} passActualizarTablaPaquetes={passActualizarTablaPaquetes}/>:null}
      {modalOnPaqueteRepetido? <ModalPaquetesRepetidos setmodalOnPaqueteRepetido={setmodalOnPaqueteRepetido}/>:null}
    </>
  )
}

export default TablaSeleccionPaquetes